import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { GetVendorResponse } from "../models/response/get-vendor-response";
import { getVendor } from "../services/vendor-service";
import { useQuery } from "@tanstack/react-query";

interface Props {
  vendorId: number | string;
}

export function useVendor({ vendorId }: Props) {
  const { data, error, isLoading, isError, refetch } = useQuery<
    GetVendorResponse,
    ApiError
  >({
    queryKey: ["vendor", vendorId],
    queryFn: () => getVendor({ vendorId }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
  };
}
